import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6a88c282&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=6a88c282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88c282",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TemplatesKEHeader: require('/var/www/packages/theme/components/templates/KEHeader.vue').default,AtomsErrorBoundary: require('/var/www/packages/theme/components/atoms/ErrorBoundary.vue').default,TemplatesKEFooter: require('/var/www/packages/theme/components/templates/KEFooter.vue').default,MoleculesKECookie: require('/var/www/packages/theme/components/molecules/KECookie.vue').default,MoleculesAddToCartExposer: require('/var/www/packages/theme/components/molecules/AddToCartExposer.vue').default})
